import { Component, AfterViewInit, QueryList, ContentChildren, ViewChildren, ElementRef, ViewChild, Input, ViewContainerRef, SimpleChanges, ChangeDetectorRef, DoCheck } from '@angular/core';
import { CarouselItemDirective } from './directives/carousel-item/carousel-item.directive';
import { CarouselItemElement } from './directives/carousel-item-element/carousel-item-element.directive';
import { ConsoleLogger } from '../moov-common/logger/console-logger';
import { BaseComponent } from '../moov-common/base/base.component';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';

@Component({
  selector: 'app-carousel',
  // exportAs: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements AfterViewInit, DoCheck {

  public carouselWrapperStyle = {};

  @ContentChildren(CarouselItemDirective) items: QueryList<CarouselItemDirective>;
  @ViewChildren(CarouselItemElement, { read: ElementRef }) private itemsElements: QueryList<ElementRef>;
  @Input() chips: Array<string> = [];
  @Input() timing = 500;
  @Input() showOverControls = false;
  @Input() showDotsStepper = false;
  @Input() showFooterControls = false;
  @Input() isRTL: boolean = false;
  @Input() commandControlsColor: string = "#000000";
  @Input() auto: { enable: boolean, timer: number } = { enable: false, timer: 0 };
  selectedChipIdx: number = 0;
  private totalItems: number;
  private slide = 0;
  private carouselItemClassName = 'carousel-item';
  private interval: any = null;
  @ViewChild('chipList') chipList: MatChipListbox;
  // previous: any;

  constructor(public cd: ChangeDetectorRef) { }

  
  ngDoCheck(){  }

  ngAfterViewInit() {
    this.initCarousel();
  }

  ngAfterViewChecked() {
    // this.selectChipByIndex(this.selectedChipIdx);
  }

  ngOnChanges(changes: SimpleChanges) {
      this.initCarousel();   
  }
  
  chipSelect(chipItem: string,  chipIdx: number): void
  {
    // console.log(`in Carousel chipSelect _chips are ${JSON.stringify(this.chipList._chips)}`)
    let chip: MatChipOption | undefined = this.chipList._chips.get(chipIdx);
    chip?.select();
    this.selectedChipIdx = chipIdx;
    this.chipSelected(chip,chipIdx)
  }
  
  chipSelected(chip: any, chipIdx: number) {
    if (chip.selected) {
      this.slide = chipIdx;
      this.moveCarouselTo(chipIdx);
    }
  }

  isChipSelected(chipIdx: number) {
    return (this.selectedChipIdx === chipIdx);
  }

  selectChipByIndex(selectedChipIdx: number) {
    let chip: MatChipOption | undefined = this.chipList._chips.get(selectedChipIdx);
    if (chip) {
      chip.selectViaInteraction();
    }
  }

  async getNgClassForChip(chip: MatChipOption) {
    return chip.selected ? 'class="originalChipSelected"' : 'class="originalChip"';
  }


  initCarousel() {
    // this.previous = this.itemsElements;
    if (!this.itemsElements || !this.itemsElements.length)
      return;
    this.totalItems = this.itemsElements.length;
    // console.log('this.itemsElements.length '+this.itemsElements.length);
    this.itemsElements.first.nativeElement.className = `${this.carouselItemClassName} initial`
    // console.log(this.totalItems);

    this.setInitialClasses();
    this.setInterval();
  }

  setInterval() {
    if (this.auto.enable) {
      this.interval = setInterval(() => {
        this.moveNext();
      }, this.auto.timer);
    }
  }

  clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  transition() {
    return { transition: `transform ${this.timing}ms, opacity ${this.timing}ms, z-index ${this.timing}ms` };
  }

  stepperDot(i: number) {
    if (i == this.slide)
      return 'dotActive';
    return 'dotNonActive';
  }

  setInitialClasses() {
    this.itemsElements.forEach((item, index) => {
      if (index === 0) {
        item.nativeElement.className = `${this.carouselItemClassName} initial active`;
      }

      if (index === 1) {
        item.nativeElement.className = `${this.carouselItemClassName} next`;
      }

      if (index === this.totalItems - 1) {
        item.nativeElement.className = `${this.carouselItemClassName} prev`;
      }
    });
  }

  // Next navigation handler
  moveNext() {
    this.slide = (this.slide + 1) % this.totalItems;
    this.moveCarouselTo(this.slide);
  }

  movePrev() {
    this.slide = ((this.slide - 1) + this.totalItems)% this.totalItems;
    this.moveCarouselTo(this.slide);
  }

  moveCarouselTo(slide: number) {
    this.clearInterval();
    this.selectedChipIdx = slide;
    this.selectChipByIndex(this.selectedChipIdx);

    // console.log('current slide to move to '+slide);
    // Update the "old" adjacent slides with "new" ones
    let newPrevious = ((slide - 1) + this.totalItems)% this.totalItems;
    let newNext = (slide + 1) % this.totalItems;
    // console.log(`newPrevious:`+ newPrevious + " newNext: "+ newNext + " slide: "+slide);
    if (this.itemsElements){
      this.itemsElements.forEach((item, index) => {
        item.nativeElement.className = this.carouselItemClassName;

        // Add new classes
        if (index === slide) {
          item.nativeElement.className = `${this.carouselItemClassName} active`;
        }

        if (index === newNext) {
          item.nativeElement.className = `${this.carouselItemClassName} next`;
        }

        if (index === newPrevious) {
          item.nativeElement.className = `${this.carouselItemClassName} prev`;
        }

      
    });

    this.setInterval();
    }
  }

}
